// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';
// local
import { PERIOD_TYPE } from 'salvus-shared/consts/patient';
import t from 'salvus-shared/lib/i18n';
// css
import './FilterUseType.scss';

class FilterUseType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: props.checked,
        };
    }

    // Helper function to check if the radio is checked
    isChecked = value => this.state.checked.indexOf(value) !== -1;

    // Handle changes in the radio
    handleChange = (e, { value }) => {
        let { checked } = this.state;
        let index = checked.indexOf(value);
        if (index === -1) {
            checked.push(value);
        } else {
            checked.splice(index, 1);
        }
        this.setState({ checked });
        // call the parent callback
        const { onChange } = this.props;
        if (onChange) {
            onChange(checked);
        }
    };

    render() {
        return (
            <div id="checkbox-user-type">
                <label>Exibir:</label>
                <Checkbox
                    label={t(`patient_period_type_${PERIOD_TYPE.CONTINUOUS_USE}`)}
                    name="uso_continuo"
                    value={PERIOD_TYPE.CONTINUOUS_USE}
                    checked={this.isChecked(PERIOD_TYPE.CONTINUOUS_USE)}
                    onClick={this.handleChange}
                />
                <Checkbox
                    label={t(`patient_period_type_${PERIOD_TYPE.IF_NECESSARY}`)}
                    name="se_necessario"
                    value={PERIOD_TYPE.IF_NECESSARY}
                    checked={this.isChecked(PERIOD_TYPE.IF_NECESSARY)}
                    onClick={this.handleChange}
                />
            </div>
        );
    }
}

FilterUseType.propTypes = {
    checked: PropTypes.array,
    onChange: PropTypes.func.isRequired,
};

export default FilterUseType;
